import { invalidate, type InvalidationTarget } from "@kontextwerk/web-sdk/core/runtime/invalidation"

export const KEHRBLATT_WORK_ORDERS_INVALIDATION_TOPIC = "kehrblatt.work_orders"
export const KEHRBLATT_WORK_ORDERS_TABLE_INVALIDATION_TOPIC = "kehrblatt.work_orders.table"

export const workOrdersInvalidationTarget = (organizationId: string): InvalidationTarget => ({
  topic: KEHRBLATT_WORK_ORDERS_INVALIDATION_TOPIC,
  scope: organizationId,
})

export const workOrdersTableInvalidationTarget = (organizationId: string): InvalidationTarget => ({
  topic: KEHRBLATT_WORK_ORDERS_TABLE_INVALIDATION_TOPIC,
  scope: organizationId,
})

export const invalidateWorkOrdersOverview = (organizationId: string) =>
  invalidate(workOrdersInvalidationTarget(organizationId))

export const invalidateWorkOrdersTable = (organizationId: string) =>
  invalidate(workOrdersTableInvalidationTarget(organizationId))
